<template>
    <b-card no-body class="p-3">
        <el-timeline>
            <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :timestamp="activity.timestamp"
            >
                {{activity.content}} <!-- <span class="text-primary" v-if="activity.content == 'Commitment'">View Details <b-icon icon="chevron-right"></b-icon></span> -->
            </el-timeline-item>
        </el-timeline>
    </b-card>
</template>
<script>
import { Timeline, TimelineItem } from 'element-ui'

export default {
    components: {
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
    },
    computed: {
        activities(){
            return  [
                {
                    content: 'Profile',
                    timestamp: 'Profile information has been filled out.',
                    size: 'large',
                    color: '#0bc196',
                    icon: 'el-icon-check',
                }, 
                {
                    content: 'Net Income',
                    timestamp: 'Net income has been filled out.',
                    size: 'large',
                    color: '#0bc196',
                    icon: '',
                }, 
                {
                    content: 'Commitment',
                    timestamp: 'Latest CTOS report has been generated on 30 Jan 2023',
                    icon: 'el-icon-check',
                    size: 'large',
                    color: '#0bc196',
                }, 
                {
                    content: 'Loan Eligibility Calculator',
                    timestamp: 'Only can be unlocked once Net Income & Commitment are added.',
                    size: 'large',
                    color: '',
                },
            ]
        }
    }
}
</script>